<template>
  <div id="subscription-result-view">
    <header>
      <div class="icon">
        <h1>Shadow</h1>
      </div>
      <h2>Launching Shadow</h2>
      <p>Click "Open Shadow" to launch the desktop app.</p>
    </header>
    <main>
      <div class="btn-group-wrap">
        <button id="btn-open-shadow" @click="open">Open Shadow</button>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "SubscriptionResultView",
  data() {
    return {};
  },
  async mounted() {
    this.open();
  },
  methods: {
    cancel() {
      alert("This is not a valid access.");
      location.href = "https://shadow.do";
    },
    open() {
      // TODO: 오픈 전에 주석 해제해야 함
      // if (!document.referrer.includes("https://buy.stripe.com")) this.cancel();

      const urlParams = new URLSearchParams(window.location.search);

      if (this.checkQueryParams(urlParams)) {
        const sessionId = urlParams.get("sessionId");

        location.href = `shadow://subscription?sessionId=${sessionId}`;
      } else {
        this.cancel();
      }
    },
    checkQueryParams(urlParams) {
      try {
        return urlParams.has("sessionId");
      } catch (error) {
        console.error(error);

        return false;
      }
    },
  },
};
</script>

<style>
body:has(#subscription-result-view) {
  background: #151515;
  color: #fff;
}
</style>

<style scoped>
#subscription-result-view {
  max-width: 720px;
  margin: 0 auto;
  padding: 5.587% 6.9835%;
}

header {
  margin-bottom: 60px;
  text-align: center;
}

header .icon {
  margin-bottom: 60px;
}

header .icon h1 {
  width: 120px;
  height: 31.2px;
  text-indent: -9999px;
  margin: 0 auto;
  background-image: url("@/assets/img/logo.png");
  background-size: cover;
}

header h2 {
  margin-bottom: 30px;
  font-size: 32px;
  font-weight: 600;
}

header p {
  font-size: 18px;
  font-weight: 300;
  color: #ccc;
}

button {
  position: relative;
  height: 36px;
  font-size: 14px;
  line-height: 34px;
  padding: 0 12px;
  border: 1px solid #777;
  border-radius: 5px;
  color: #aaa;
  background-color: #1d2021;
  cursor: pointer;
  text-align: center;
}

div.btn-group-wrap {
  text-align: center;
}

div.btn-group-wrap button {
  font-size: 16px;
}

#btn-open-shadow {
  width: 240px;
  height: 40px;
  border: 1px solid #d65d0e;
  background: #d65d0e;
  color: #fff;
  font-weight: 600;
}
</style>
